import Cookie from 'universal-cookie'
import { captureException } from '@sentry/node'
import { init } from '../../sentry'

init()

const cookie = new Cookie()
export const tokenKey = '_B__bkAzwL__Wh6EZFzxefrci'

export default async function client(endpoint, init = {}, config = {}) {
  const safeToken = config.token || cookie.get(tokenKey)

  const headers = {}
  if (safeToken) {
    headers.Authorization = `Bearer ${safeToken}`
  }

  const fancyInit = {
    credentials: 'include',
    ...init,
    headers: {
      ...headers,
      ...init.headers,
    },
  }

  return fetch(endpoint, fancyInit).then(async (response) => {
    if (response.status === 401) {
      cookie.remove(tokenKey, { path: '/' })

      if (typeof config.onUnauthorized === 'function') config.onUnauthorized(response)
      if (typeof window !== 'undefined') window.location.assign('/')

      return Promise.reject(response)
    }

    try {
      const data = await response.json()

      if (response.ok) return Promise.resolve(data)

      captureException(new Error('API Response status not OK'), response)
      return Promise.reject(data)
    } catch (err) {
      captureException(err, response)
      return Promise.reject(err)
    }
  })
}
